<style>
.bg-primary {
  background-color: #1a3665 !important;
}
</style>
<template>
  <CCard>
    <CCardHeader
      class="bg-primary text-white border-0 font-weight-bold p-3 d-flex align-items-center font-weight-bold"
    >
      Master Lokasi Kota/Kab      
      <template v-if="role_status && role_status.status_create">
      <CButton
        color="success"        
        class="btn-md ml-auto button-md-block px-3"
        @click="createData">Tambah</CButton>
      </template>
      <template v-else>
      <CButton
        color="secondary"        
        class="btn-md ml-auto button-md-block px-3"
        disabled>Tambah</CButton>
      </template>
    </CCardHeader>
    <!-- tabs -->
    <ul class="nav nav-tabs bg-active border-0" id="myTab" role="tablist">
      <li class="nav-item">
        <router-link
          to="/data-master/master-lokasi"
          class="nav-link p-3 px-5 font-weight-bold text-white"
          id="home-tab"
          data-toggle="tab"
          href="#home"
          role="tab"
          aria-controls="home"
          aria-selected="true"
          >Provinsi</router-link
        >
      </li>
      <li class="nav-item">
        <router-link
          to="/data-master/master-lokasi-kota"
          class="nav-link p-3 px-5 font-weight-bold text-white border-0"
          style="background-color: #486ba7"
          id="profile-tab"
          data-toggle="tab"
          href="#profile"
          role="tab"
          aria-controls="profile"
          aria-selected="false"
          >Kota/Kab</router-link
        >
      </li>
      <li class="nav-item">
        <router-link
          to="/data-master/master-lokasi-kecamatan"
          class="nav-link p-3 px-5 font-weight-bold text-white"
          id="contact-tab"
          data-toggle="tab"
          href="#contact"
          role="tab"
          aria-controls="contact"
          aria-selected="false"
          >Kecamatan</router-link
        >
      </li>
    </ul>
    <!-- end tabs -->
    <!-- Data kota/kab -->
    <CCardBody>
      <CRow>
        <div class="col-sm-12 col-xl-2">
          <div class="form-group">
            <CSelect
              label="Data Perhalaman"
              class="float-left"
              @change="changePageSize"
              :options="[10, 25, 100, 'Semua Data']"
            />
          </div>
        </div>
        <div class="col-sm-12 col-xl-3 ml-auto">
          <div class="form-group">
            <label for>Pencarian</label>
            <input
              type="text"
              v-model="search"
              name
              id
              class="form-control"
              placeholder="Cari Data ..."
            />
          </div>
        </div>
      </CRow>
      <CRow>
        <CCol lg="12" class="table-responsive">
          <CDataTable
            style="widht: 100% !important"
            :items="items"
            :fields="fields"
            hover
            sorter
          >
            <template #no="{ index }">
              <td class="py-2">
                {{ indexed == 0 ? index + 1 : index + indexed + 1 }}
              </td>
            </template>
            <!-- <template #kode="{item}">
              <td class="py-2 text-center font-weight-bold">{{item.kode ? item.kode : "-"}}</td>
            </template> -->
            <template #name="{ item }">
              <td class="py-2 text-left">{{ item.name ? item.name : "-" }}</td>
            </template>
            <template #status="{ item }">
              <td class="py-2 text-center">
                <font-awesome-icon
                  icon="check"
                  class="text-success"
                  v-if="item.status == 1"
                />
                <font-awesome-icon icon="times" class="text-danger" v-else />
              </td>
            </template>
            <template #aksi="{ item, index }">
              <td class="py-2 text-center">
                <template v-if="role_status && role_status.status_update">
                <CButton v-c-tooltip="'Ubah'" color="info" square size="sm" @click="updateData(item, index)">
                  <font-awesome-icon icon="edit" />
                </CButton>&nbsp;&nbsp;
                </template>
                <template v-else>
                <CButton v-c-tooltip="'Ubah'" color="secondary" square size="sm" disabled>
                  <font-awesome-icon icon="edit" />
                </CButton>&nbsp;&nbsp;
                </template>
                <template v-if="role_status && role_status.status_delete">
                <CButton v-c-tooltip="'Hapus'" color="danger" square size="sm" @click="deleteData(item, index)">
                  <font-awesome-icon icon="trash" />
                </CButton>
                </template>
                <template v-else>
                <CButton v-c-tooltip="'Hapus'" color="secondary" square size="sm" disabled>
                  <font-awesome-icon icon="trash" />
                </CButton>
                </template>
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float: right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
          />
        </CCol>
      </CRow>
      <!-- Modal Tambah -->
      <CModal
        title="Modal title"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CForm v-on:submit.prevent="postData">
          <CRow>
            <CCol sm="12">
              <multiselect
                label="name"
                required
                placeholder="Pilih Provinsi"
                @input="pilihProvinsi"
                v-model="multi_provinsi"
                :options="optionProvinsi"
              ></multiselect>
              <span v-if="$v.formData.provinceId.$error" class="text-danger">
                *Mohon pilih Provinsi
              </span>
            </CCol>
            <CCol sm="12">
              <label for="nama_dokument" class="font-weight-bold"
                >Nama Kota</label
              >
              <input
                type="text"
                class="form-control"
                :class="{
                  'is-invalid': $v.formData.name.$error,
                }"
                id="nama_kota"
                placeholder="Masukkan Nama Kota"
                v-model="formData.name"
                @input="setNamaKota($event.target.value)"
              />
            </CCol>

            <CCol sm="12 mb-4">
              <label for class="font-weight-bold">Status</label>
              <br />
              <div class="d-flex align-items-center">
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadio"
                    id="aktif"
                    value="1"
                    v-model="formData.status"
                    checked
                  />
                  <label class="custom-control-label" for="aktif">Aktif</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadio"
                    id="tidak_aktif"
                    value="0"
                    v-model="formData.status"
                  />
                  <label class="custom-control-label" for="tidak_aktif"
                    >Tidak Aktif</label
                  >
                </div>
              </div>
              <span v-if="$v.formData.status.$error" class="text-danger">
                *Mohon pilih status
              </span>
            </CCol>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">{{ title }}</h6>
        </template>
        <template #footer>
          <CButton @click="closeModal" color="danger">Tutup</CButton>
          <CButton @click="postData" type="submit" color="success"
            >Simpan</CButton
          >
        </template>
      </CModal>
      <!-- End Modal -->
    </CCardBody>
    <!-- end data kota/kab -->
  </CCard>
</template>
<script>
import { required } from "vuelidate/lib/validators";

import KotaKabupatenService from "../../services/datamaster/kota-kabupaten.service";
import ProvinsiService from "../../services/datamaster/provinsi.service";

// mixins
import { AlertUtils } from "../../mixins/AlertUtils";
import { Pagination } from "../../mixins/Pagination";
const fields = [
  {
    key: "no",
    _style: "width: 5%;",
  },
  // {
  //   key: "kode"
  // },
  {
    key: "name",
    label: "Nama",
    _style: "text-align: left",
  },
  { key: "status", _style: " text-align: center" },
  { key: "aksi", _style: "width:15%; text-align: center" },
];

export default {
  name: "Master Lokasi",
  mixins: [AlertUtils, Pagination],
  data() {
    return {
      actionPost: "",
      formData: {
        kode: "",
        name: "",
        status: "",
        idKotaKab: "",
        provinceId: "",
      },
      multi_provinsi: [],
      fields,
      details: [],
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },
      optionProvinsi: [],
      collapseDuration: 0,
      content: [],
      role_data: null
    };
  },

  validations: {
    formData: {
      provinceId: { required },
      name: { required },
      status: { required },
    },
  },

  watch: {
    myModal: function () {
      if (!this.myModal) {
        // reset validation ketika modal ditutup
        this.$v.$reset();
        document.getElementById("nama_kota").classList.remove("is-valid");
      }
    },
  },

  mounted() {
    var vm = this;
    vm.getData("0", vm.pageSize, vm.search);
    this.getAllProvinsi();
    this.roleData();
    // vm.alertSuccess();
  },

  methods: {
    setNamaKota(value) {
      this.formData.name = value;
      this.$v.formData.name.$touch();
      if (!this.$v.formData.name.$error) {
        document.getElementById("nama_kota").classList.add("is-valid");
      }
    },
    pilihProvinsi(value) {
      // comment console console.log(value.idProvinsi);
      this.formData.provinceId = value.idProvinsi;
      this.$v.formData.provinceId.$reset();
    },
    getAllProvinsi() {
      ProvinsiService.getAllProvinsi()
        .then((response) => {
          this.optionProvinsi = response.data.data.content;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },
    deleteData(item, index) {
      this.formData = item;
      var vm = this;
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            KotaKabupatenService.deleteKotaKabupaten(item.id_kota_kab)
              .then((response) => {
                // comment console console.log(response);
                this.alertDeleteSuccess();
                vm.getData("0", vm.pageSize, vm.search);
              })
              .catch((error) => {
                this.alertError();
                // comment console console.log(error);
              });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },
    getData(currentPage, pageSize, filter) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      var vm = this;

      KotaKabupatenService.getKotaKabupaten(currentPage, pageSize, filter)
        .then((response) => {
          loader.hide();
          // comment console console.log(response.data.data.content);
          vm.items = response.data.data.content;
          vm.pagination.totalPages = response.data.data.totalPages;
          vm.currentPage = response.data.data.pageable.pageNumber + 1;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },

    createData() {
      this.myModal = true;
      this.formData = {};
      this.actionPost = "insert";
      this.title = "Tambah";
    },

    updateData(item, index) {
      this.myModal = true;
      this.formData = item;
      this.actionPost = "update";
      this.title = "Edit";
      this.multi_provinsi = [
        {
          name: item.nama_provinsi,
        },
      ];
    },

    postData() {
      if (this.actionPost == "insert") {
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        } else {
          this.insertData(this.formData);
        }
      } else if (this.actionPost == "update") {
        this.putData();
      }
    },

    insertData(formData) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      // comment console console.log(formData);
      // comment console console.log("posat");
      var vm = this;
      KotaKabupatenService.postKotaKabupaten(formData)
        .then((response) => {
          loader.hide();
          this.myModal = false;
          this.alertSuccess();
          vm.getData("0", vm.pageSize, vm.search);
        })
        .catch((error) => {
          loader.hide();
          // comment console console.log(error);
          this.alertError(error.response.data.message);
        });
    },

    putData() {
      // comment console console.log("put");
      // comment console console.log(this.formData);
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      KotaKabupatenService.putKotaKabupaten(this.formData)
        .then((response) => {
          this.myModal = false;

          this.alertEditSuccess();
          loader.hide()
          this.getData("0", vm.pageSize, vm.search);
        })
        .catch((error) => {
          // comment console console.log(error);
          loader.hide();
          this.alertError(error.response.data.message);
        });
    },

    closeModal() {
      this.myModal = false;
      this.$v.$reset();
      document.getElementById("nama_kota").classList.remove("is-valid");
    },
    roleData()
    {
      var user = JSON.parse(localStorage.getItem('user'));
      var data = user.singleData.detail_user.roles.find(el => el.url === '/data-master/master-lokasi' );  
      this.role_status = data;
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
